import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Input,
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import CustomSelect from "components/Common/custom-select";
import CustomDatePicker from "common/CustomDatePicker";
import TableContainer from "components/Common/TableContainer";
import { useFormik } from "formik";
import * as Yup from "yup";

const departmentOptions = [
  { label: "QUALITY CONTROL", value: "QUALITY CONTROL" },
  { label: "CUTTING", value: "CUTTING" },
  { label: "Admin", value: "Admin" },
  { label: "STORE", value: "STORE" },
  { label: "IED", value: "IED" },
  { label: "PACKING", value: "PACKING" },
  { label: "PRODUCTION", value: "PRODUCTION" },
  { label: "QUALITY", value: "QUALITY" },
  { label: "ANCILLARY", value: "ANCILLARY" },
];

const categoryOptions = [
  { label: "Admin", value: "Admin" },
  { label: "Staff", value: "Staff" },
  { label: "Foreman", value: "Foreman" },
];

const AttendanceReportPresentDays = () => {
  const formik = useFormik({
    initialValues: {
      department: "",
      category: "",
      fromDate: "",
      toDate: "",
      code: "",
      name: "",
    },
    validationSchema: Yup.object({
      fromDate: Yup.string().required("From Date is required"),
      toDate: Yup.string().required("To Date is required"),
    }),
    onSubmit: (values) => {
      console.log("Search values:", values);
    },
  });

  const data = [
    { code: "0", name: "AES ADMIN", department: "Admin", presentDays: "0.0" },
    { code: "001", name: "ARUN", department: "QUALITY CONTROL", presentDays: "1.0" },
    { code: "002", name: "VIGNESH", department: "PRODUCTION", presentDays: "1.0" },
    { code: "003", name: "ULAGURAJ", department: "PACKING", presentDays: "1.0" },
    { code: "00320", name: "NAVEEN", department: "PACKING", presentDays: "1.0" },
    { code: "005", name: "PARAMESH", department: "CUTTING", presentDays: "1.0" },
    { code: "00585", name: "JAANU", department: "QUALITY", presentDays: "1.0" },
    { code: "006", name: "REVATHY", department: "Admin", presentDays: "0.5" },
    { code: "007", name: "REKHA", department: "CUTTING", presentDays: "1.0" },
    { code: "008", name: "MALLIKA", department: "ANCILLARY", presentDays: "1.0" },
  ];

  const columns = [
    { Header: "S No", Cell: ({ row }) => data.length - row.index, className: "serial-no text-center", },
    { Header: "Code", accessor: "code" },
    { Header: "Employee Name", accessor: "name" },
    { Header: "Department", accessor: "department" },
    { Header: "Present Days", accessor: "presentDays" },
  ];

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Attendance" breadcrumbItem="Present Days" />
        <Card>
          <CardBody>
            <form onSubmit={formik.handleSubmit}>
              <Row className="gy-3">
                <Col md={4}>
                  <Label>Category</Label>
                  <CustomSelect
                    name="category"
                    value={formik.values.category}
                    onChange={(val) => formik.setFieldValue("category", val)}
                    options={categoryOptions}
                    placeholder="--Select--"
                  />
                </Col>

                <Col md={4}>
                  <Label>
                    From Date <span className="text-danger">*</span>
                  </Label>
                  <CustomDatePicker
                    name="fromDate"
                    value={formik.values.fromDate}
                    onChange={(val) => formik.setFieldValue("fromDate", val)}
                    onBlur={() => formik.setFieldTouched("fromDate", true)}
                  />
                  {formik.touched.fromDate && formik.errors.fromDate ? (
                    <div className="text-danger">{formik.errors.fromDate}</div>
                  ) : null}
                </Col>

                <Col md={4}>
                  <Label>
                    To Date <span className="text-danger">*</span>
                  </Label>
                  <CustomDatePicker
                    name="toDate"
                    value={formik.values.toDate}
                    onChange={(val) => formik.setFieldValue("toDate", val)}
                    onBlur={() => formik.setFieldTouched("toDate", true)}
                  />
                  {formik.touched.toDate && formik.errors.toDate ? (
                    <div className="text-danger">{formik.errors.toDate}</div>
                  ) : null}
                </Col>

                <Col md={4}>
                  <Label>Code</Label>
                  <Input
                    name="code"
                    value={formik.values.code}
                    onChange={formik.handleChange}
                    className="form-control"
                  />
                </Col>

                <Col md={4}>
                  <Label>Name</Label>
                  <Input
                    name="name"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    className="form-control"
                  />
                </Col>

                <Col md={4}>
                  <Label>Department</Label>
                  <CustomSelect
                    name="department"
                    value={formik.values.department}
                    onChange={(val) => formik.setFieldValue("department", val)}
                    options={departmentOptions}
                    placeholder="--Select--"
                  />
                </Col>

                <Col md={12} className="text-end">
                  <Button type="submit" className="btn button-search me-2 mt-2">
                    <i className="fas fa-search me-1" /> Search
                  </Button>
                  <Button type="button" className="btn button-print mt-2">
                    <i className="fas fa-print me-1" /> Print
                  </Button>
                </Col>
              </Row>
            </form>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <TableContainer
              columns={columns}
              data={data}
              isGlobalFilter={true}
              customPageSize={10}
              tableSorter={true}
            />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default AttendanceReportPresentDays;
